const TIME_OFF_REQUEST_STATUSES = [
  'pending',
  'approved',
  'rejected'
];

export default TIME_OFF_REQUEST_STATUSES;
